import { Container } from "@mui/material";
import { AuthStatus, useAuth } from "../auth/Auth";
import LoadingPage from "../loading/LoadingPage";
import SupportTicket from "./SupportRequest";

const HelpPage = () => {
    const auth = useAuth();
    const user = auth.user;

    if (auth.status === AuthStatus.Loading) {
        return <LoadingPage />;
    }

    return (
        <Container maxWidth='lg' sx={{ pt: 4, marginBottom: '100px' }}>
            <SupportTicket user={user} />
        </Container>
    )

}

export default HelpPage;